import { LNG } from './LanguageService';

// eslint-disable-next-line no-extend-native
Date.prototype.toJSON = function () {
    //use custom implementation for better performance
    const useZeroDate = this.getFullYear() < 1000
    let year = this.getUTCFullYear().toString()
    let month = (this.getUTCMonth() + 1).toString()
    let day = this.getUTCDate().toString()
    let hh = this.getUTCHours().toString()
    let mm = this.getUTCMinutes().toString()
    let ss = this.getUTCSeconds().toString()
    if (useZeroDate) {
        year = '0001'
        month = '1'
        day = '1'
        hh = this.getHours().toString()
        mm = this.getMinutes().toString()
        ss = '0'
    }
    if (month.length === 1)
        month = '0' + month
    if (day.length === 1)
        day = '0' + day
    if (hh.length === 1)
        hh = '0' + hh
    if (mm.length === 1)
        mm = '0' + mm
    if (ss.length === 1)
        ss = '0' + ss

    return `${year}-${month}-${day}T${hh}:${mm}:${ss}${useZeroDate ? '' : 'Z'}`
}
export default class DateTimeService {
    static ISO_8601_date: RegExp = /^\d{4}-\d\d-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?$/i
    static regExpDateMask: RegExp = /(YYYY|YY|MMMM|MMM|MM|M|DD|D|dd|d|HH|H|mm|ss|SSS)/g
    static monthNames: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    static weekDayNames2Letters: string[] = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']

    static fromString(value: string): Date {
        return new Date(Date.parse(value))
    }

    static addDays(date: Date, days: number): Date {
        return new Date(date.getTime() + days * 24 * 60 * 60 * 1000)
    }

    static addYears(date: Date, years: number): Date {
        return new Date(
            Date.UTC(
                (date.getUTCFullYear() + years),
                date.getUTCMonth(),
                date.getUTCDate(),
                date.getUTCHours(),
                date.getUTCMinutes(),
                date.getUTCSeconds(),
            )
        );
    }

    static format(date: Date, format: string = 'DD.MM.YYYY'): string {
        let result = format
        result = result.replace(this.regExpDateMask, (match: string) => {
            switch (match) {
                case 'DD':
                    return date.getUTCDate() < 10 ? '0' + date.getUTCDate() : date.getUTCDate().toString()
                case 'D':
                    return date.getUTCDate().toString()
                case 'dd':
                    let dayOfWeek = date.getUTCDay() - 1
                    if (dayOfWeek < 0) {
                        dayOfWeek = 6
                    }
                    return this.weekDayNames2Letters[dayOfWeek]
                case 'MMMM':
                    return this.monthNames[date.getUTCMonth()]
                case 'MMM': {
                    const monthNames = [
                        LNG.Text('Dashboard.233'),
                        LNG.Text('Dashboard.234'),
                        LNG.Text('Dashboard.235'),
                        LNG.Text('Dashboard.236'),
                        LNG.Text('Dashboard.237'),
                        LNG.Text('Dashboard.238'),
                        LNG.Text('Dashboard.239'),
                        LNG.Text('Dashboard.240'),
                        LNG.Text('Dashboard.241'),
                        LNG.Text('Dashboard.242'),
                        LNG.Text('Dashboard.243'),
                        LNG.Text('Dashboard.244'),
                    ]
                    return monthNames[date.getMonth()]
                }
                case 'MM':
                    return date.getUTCMonth() + 1 < 10 ? '0' + (date.getUTCMonth() + 1).toString() : (date.getUTCMonth() + 1).toString()
                case 'M':
                    return (date.getUTCMonth() + 1).toString()
                case 'YYYY':
                    return date.getUTCFullYear().toString()
                case 'YY':
                    return date.getUTCFullYear().toString().substr(-2)
                case 'HH':
                    return date.getUTCHours() < 10 ? '0' + date.getUTCHours() : date.getUTCHours().toString()
                case 'H':
                    return date.getUTCHours().toString()
                case 'mm':
                    return date.getUTCMinutes() < 10 ? '0' + date.getUTCMinutes() : date.getUTCMinutes().toString()
                case 'ss':
                    return date.getUTCSeconds() < 10 ? '0' + date.getUTCSeconds() : date.getUTCSeconds().toString()

                default:
                    return match
            }
        })
        return result
    }

    static formatLocal(date: Date, format: string = 'DD.MM.YYYY'): string {
        let result = format
        result = result.replace(this.regExpDateMask, (match: string) => {
            switch (match) {
                case 'DD':
                    return date.getDate() < 10 ? '0' + date.getDate() : date.getDate().toString()
                case 'D':
                    return date.getDate().toString()
                case 'dd':
                    let dayOfWeek = date.getDay() - 1
                    if (dayOfWeek < 0) {
                        dayOfWeek = 6
                    }
                    return this.weekDayNames2Letters[dayOfWeek]
                case 'MMMM':
                    return this.monthNames[date.getMonth()]
                case 'MMM': {
                    const monthNames = [
                        LNG.Text('Dashboard.233'),
                        LNG.Text('Dashboard.234'),
                        LNG.Text('Dashboard.235'),
                        LNG.Text('Dashboard.236'),
                        LNG.Text('Dashboard.237'),
                        LNG.Text('Dashboard.238'),
                        LNG.Text('Dashboard.239'),
                        LNG.Text('Dashboard.240'),
                        LNG.Text('Dashboard.241'),
                        LNG.Text('Dashboard.242'),
                        LNG.Text('Dashboard.243'),
                        LNG.Text('Dashboard.244'),
                    ]
                    return monthNames[date.getMonth()]
                }
                case 'MM':
                    return date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
                case 'M':
                    return (date.getMonth() + 1).toString()
                case 'YYYY':
                    return date.getFullYear().toString()
                case 'YY':
                    return date.getFullYear().toString().substr(-2)
                case 'HH':
                    return date.getHours() < 10 ? '0' + date.getHours() : date.getHours().toString()
                case 'H':
                    return date.getHours().toString()
                case 'mm':
                    return date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes().toString()
                case 'ss':
                    return date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds().toString()

                default:
                    return match
            }
        })
        return result
    }

    static now(): Date {
        return new Date()
    }

    static date(year: number, month: number, day: number): Date {
        return new Date(Date.UTC(year, month, day, 0, 0, 0, 0))
    }

    static zeroDate(date: Date): Date {
        const zeroDate = new Date('0001-01-01')
        zeroDate.setHours(date.getHours(), date.getMinutes(), 0, 0)
        return zeroDate
    }

    static today(): Date {
        let today = new Date()
        return DateTimeService.date(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate())
    }

    static getMinutesFromMidnight(date: Date): number {
        return date.getHours() * 60 + date.getMinutes()
    }

    static todayLocal(includeHours = false): Date {
        const today = new Date()
        if (includeHours) {
            today.setMinutes(0, 0, 0)
        } else {
            today.setHours(0, 0, 0, 0)
        }

        return today
    }

    static addTime(date: Date, hours: number, minutes?: number): Date {

        let offset = hours * 60 * 60 * 1000
        if (minutes) {
            offset += minutes * 60 * 1000
        }

        return new Date(date.getTime() + offset)
    }

    static getLocalTimeZone(): string {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
}
